import type { SliceMetric } from '@death-star/shared';

export const METRIC_TABS: readonly SliceMetric[] = [
  'auto_approval', 'ttm', 'ttfr', 'revert_rate', 'override_rate', 'council_wall_clock',
  'findings_per_run', 'substantive_share', 'severity_mix',
];

export const METRIC_LABELS: Record<SliceMetric, string> = {
  auto_approval: 'Auto-approval',
  ttm: 'Time-to-merge',
  ttfr: 'Time-to-first-review',
  revert_rate: 'Revert rate',
  override_rate: 'Override rate',
  council_wall_clock: 'Council wall-clock (p95)',
  findings_per_run: 'Findings per run',
  substantive_share: 'Substantive share',
  severity_mix: 'Severity mix',
};

export interface MetricTabsProps {
  active: SliceMetric;
  onSelect: (metric: SliceMetric) => void;
}

export function MetricTabs({ active, onSelect }: MetricTabsProps) {
  return (
    <div
      className="filter-toggle"
      style={{
        marginBottom: 18,
        paddingBottom: 14,
        borderBottom: '1px solid var(--loop-neutral-300)',
        overflowX: 'auto',
      }}
    >
      {METRIC_TABS.map((m) => (
        <button
          key={m}
          type="button"
          onClick={() => onSelect(m)}
          className={`filter-btn${active === m ? ' active' : ''}`}
          aria-pressed={active === m}
        >
          {METRIC_LABELS[m]}
        </button>
      ))}
    </div>
  );
}
